import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppBar, Badge, Box, Hidden, IconButton, Toolbar } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			[theme.breakpoints.up('lg')]: {
				display: 'none',
			},
		},
	}),
);

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
	const classes = useStyles();
	const [notifications] = useState([]);

	return (
		<AppBar className={classes.root} elevation={0} {...rest}>
			<Toolbar>
				<RouterLink to="/" style={{ lineHeight: 0 }}>
					<img alt="Logo Parcels App" src='//dvow0vltefbxy.cloudfront.net/assets/logo-c151ed396f2a7b7e0b34ba1490740dd9547013b7645c74af377b1dd60cf6aa3b.png' width="40px" height="40px" />
				</RouterLink>
				<Box sx={{ flexGrow: 1 }} />
				<Hidden lgDown>
					<IconButton color="inherit">
						<Badge badgeContent={notifications.length} color="primary" variant="dot">
							<NotificationsIcon />
						</Badge>
					</IconButton>
					<IconButton color="inherit">
						<InputIcon />
					</IconButton>
				</Hidden>
				<Hidden lgUp>
					<IconButton color="inherit" onClick={onMobileNavOpen}>
						<MenuIcon />
					</IconButton>
				</Hidden>
			</Toolbar>
		</AppBar>
	);
};

DashboardNavbar.propTypes = {
	onMobileNavOpen: PropTypes.func,
};

export default DashboardNavbar;
